/**
 * Canonical public-profile identifier and href helpers.
 * Prefer handle, then public_id. Never invent bare internal numeric IDs.
 */

export function getPublicProfileId(user) {
  if (!user || typeof user !== "object") return null;
  if (typeof user.handle === "string" && user.handle) return user.handle;
  if (user.public_id != null && user.public_id !== "") return String(user.public_id);
  return null;
}

export function getPublicProfileHref(user) {
  const id = getPublicProfileId(user);
  return id ? `/user/${id}` : null;
}
